import React, { useEffect, useState, useCallback } from "react";
// import AdminMenu from "../../../components/Admin/MenuDetalhes/AdminMenu";

import {
  // Container,
  Content,
  // Title,
  // SemanticTable,
  // Redirect,
  // RedirectButton,
  // TableButton,
  Field,
  Input,
  Label,
  WarningRed,
  WarningYellow,
  SubmitButton,
  DetailButton,
  FullLoader
  // StyledRow,
} from "./styles";
import { producaov2 as api } from "../../../services/apis";
import { FaTruck, FaWhatsapp } from "react-icons/fa";

import { TableContainer, TableHead, TableRow, Paper, TableCell, TableBody, Table, Select, MenuItem } from '@material-ui/core';

// import { Link } from "react-router-dom";

import {
  Modal,
  Button,
  Checkbox,
  Segment,
  Pagination,
  Icon,
  Dropdown,
  Loader,
} from "semantic-ui-react";
import { systemLogs } from "../../../services/system_logs";
import swal from "sweetalert";
import { useRouter } from "../../../hooks/router";
import cleanTitle from "../../../utils/cleanTitle";
import { smallDateFormat, smallDateFormatWithTime } from "../../../utils/Utils";
import { getUserNode } from "../../../services/auth_node";

const ControleEnvios = () => {
  const [envios, setEnvios] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [open, setOpen] = useState(false);
  const [isOpenInfos, setIsOpenInfos] = useState(false);
  const [size, setSize] = useState(0);
  const [sendMail, setSendMail] = useState(false);
  const [page, setPage] = useState(1);
  const [pageQuant, setPageQuant] = useState(1);
  const [filterStatus, setFilterStatus] = useState("");
  const [filterType, setFilterType] = useState("");
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [relatorioDataDe, setRelatorioDataDe] = useState();
  const [relatorioDataAte, setRelatorioDataAte] = useState();
  const [isRelatorioModalOpen, setIsRelatorioModalOpen] = useState(false);
  const [loadDataPedido, setLoadDataPedido] = useState(true);
  const [dataPedidoSelecionado, setDataPedidoSelecionado] = useState({});
  const [tipoVerificadoModal, setTipoVerificadoModal] = useState();
  const [resultCount, setResultCount] = useState({});
  const [modalDataEnvio, setModalDataEnvio] = useState({});
  const [modalCodigoRastreio, setModalCodigoRastreio] = useState(modalDataEnvio.codigo_rastreio || "");
  const router = useRouter();

  const dropdownTipoOptions = [
    { key: 0, value: "", text: "Todos" },
    { key: 1, value: "material", text: "Material" },
    { key: 2, value: "certificado", text: "Certificado" },
  ];

  const dropdownStatusOptions = [
    // devido ao ódio da situação
    { key: 666, value: 666, text: "Todos" },
    { key: 0, value: 0, text: "Em aberto" },
    { key: 1, value: 1, text: "Enviado para gráfica" },
    { key: 2, value: 2, text: "Aguardando código de rastreio" },
    { key: 3, value: 3, text: "Código Enviado" },
  ];

  const show = (size, index, envio) => {
    setSize(size);
    setOpen(true);
    setModalDataEnvio(envio);
    // setActiveIndex(index);
  };

  const close = () => {
    setOpen(false);
    setModalCodigoRastreio("");
    setModalDataEnvio({});
  };

  // useEffect(() => {
  //   const { tipo, status } = router.query;

  //   const typeOptions = {
  //     Mat: "material",
  //     Cert: "certificado",
  //   };

  //   const statusOptions = ["pendente", "enviado", "preparacao"];8

  //   const filter = {
  //     type: typeOptions[tipo] || "",
  //     status: status || "",
  //   };

  //   setFilterType(filter.type);
  //   setFilterStatus(filter.status);
  // }, [router]);

  const getEnvios =
    async (page = 1) => {
      setLoading(true);

      const params = {
        page,
      };

      if(filterType !== "") {
        params.type = filterType

      }
      if(search && search !== ""){
        params.search = search
      }
      if (filterStatus !== 666 && filterStatus !== "") {
        params.status = filterStatus;
      }

      const {
        envios: newEnvios,
        page: newPage,
        resultado_count,
        pageQuant: newPageQuant,
      } = (
        await api
          .get(
            `admin/envios`,
            { params },
            {
              headers: {
                access_token: `voitto-token ${localStorage.getItem(
                  "oauth_token"
                )}`,
              },
            }
          )
          .then((res) => {
            setLoading(false);
            return res;
          })
          .catch(() => {
            setLoading(false);
            return {
              data: [],
            };
          })
      ).data;

      setEnvios(newEnvios);
      setPage(newPage);
      setPageQuant(newPageQuant);
      setResultCount(resultado_count);
    };

  // const handlePage = useCallback(
  //   (e, f) => {
  //     const newPage = f.activePage;

  //     getEnvios(newPage);
  //   },
  //   [getEnvios]
  // );

  useEffect(() => {
    getEnvios();
  }, [filterType, filterStatus]);

  // const createOrUpdateEnvio = async (envio, sendMail = false) => {
  //   try {
  //     const res = await api.post(`admin/envios/codigo_rastreio`, {
  //       sendMail,
  //       dataPedidoSelecionado: {
  //         id_pedido: envio.id_pedido,
  //         data: envio.data,
  //         id_pessoa: envio.pessoa.id,
  //         id_curso: envio.curso.id,
  //         certificado: envio.tipo === "certificado" ? envio.id_curso_item : "",
  //         material: envio.tipo === "material" ? envio.id_curso_item : "",
  //         carta_escrita: envio.carta_escrita,
  //         codigo_rastreio: modalCodigoRastreio ? modalCodigoRastreio : envio.codigo_rastreio,
  //         tipo: envio.tipo,
  //         model: envio.model,
  //       },
  //     });
  //     await attEnvioStatus(envio.id, 3);

  //     await systemLogs(
  //       "controleEnvios",
  //       `criou um envio de id=${res.data.dados.id}`
  //     );

  //     return res.data.dados;
  //   } catch (err) {
  //     console.error(err);

  //     swal("Erro !", "Não foi possível criar/atualizar este envio", "error");
  //   }
  // };

  // const handleCartaEscrita = useCallback(
  //   (e, index) => {
  //     const newEnvios = [...envios];
  //     newEnvios[index].carta_escrita =
  //       newEnvios[index].carta_escrita === 1 ? 0 : 1;

  //     createOrUpdateEnvio(newEnvios[index]);

  //     setEnvios(newEnvios);
  //   },
  //   [envios]
  // );

  const handleCodigoRastreio =
    (e) => {

      setModalCodigoRastreio(e.target.value);
      // modalDataEnvio.codigo_rastreio = e.target.value;
      
      // const newEnvios = [...envios,modalDataEnvio];
      // setEnvios(newEnvios);
    };

  const sendCodigoRastreio = async (id_envio) => {
    // const newEnvios = [...envios];

    // const updatedEnvio = await createOrUpdateEnvio(
    //   envio,
    //   sendMail
    // );

    try {
      const change_status = api.put(`/admin/envios/update/${id_envio}`, {
        status: 3,
        codigo_rastreio: modalCodigoRastreio

      });
      if (change_status.status === 200) {
        swal("Alteração concluída", "", "success");
        await systemLogs("Alteração de código de rastreio", `O usuário ${getUserNode().id || "nao encontrado"} alterou o status de rastreio: ${id_envio} para: ${3} `);
        return;
      }

    } catch (error) {
      swal("Tente Novamente", "Ocorreu um erro interno no servidor", "error")
    }

    // setEnvios(newEnvios);

    close();
    getEnvios();
    // window.location.reload();
  };

  // const handleRelatorio = () => {
  //   api.post(`/admin/reports/envios-materiais`,
  //     {
  //       date_de: relatorioDataDe || "2020-01-01",
  //       data_ate: relatorioDataAte || "2050-01-01"
  //     }
  //   )
  //     .then((response) => {
  //       window.open(response.data.url);
  //     });
  // };

  const handleDadosDoPedido = async (id_pedido, tipo) => {
    setLoadDataPedido(true);
    setTipoVerificadoModal(tipo === "material" ? 1 : 0)
      const data_pedido = await api.get(`admin/pedido/envios/dados-pedido/${id_pedido}`);

      if (data_pedido.data) {
        setDataPedidoSelecionado(data_pedido.data.pessoaCurso);
        setLoadDataPedido(false);
        return;
      }

      swal("Erro nos dados:", "Consultar dados de pedido do usuário e chamar o time de TI", "warning")
  };


  const attEnvioStatus = async (id_envio, status) => {

    try {
      const change_status = api.put(`/admin/envios/update/${id_envio}`, {
        status: status
      });
      if (change_status.status === 200) {
        swal("Alteração concluída", "", "success");
        await systemLogs("Alteração de Status de Envio", `O usuário ${getUserNode().id || "nao encontrado"} alterou o status do envio: ${id_envio} para: ${status} `);
        return;
      }

    } catch (error) {
      swal("Tente Novamente", "Ocorreu um erro interno no servidor", "error")
    }
  };

  const handleOpenWPMessage = (number, name, product) => {
    if (!number) {
      swal("Atenção", "Usuário não possui número registrado", "warning")
    };
    const formatedNumber = number
      .replace("+", "")
      .replace("-", "")
      .replace("_", "")
      .replace("(", "")
      .replace(")", "")
      .replace(" ", "");
    const link = `https://wa.me//${formatedNumber}?text=${encodeURIComponent(
      `Olá ${name.split(" ")[0]
      }! Aqui é o Lúcio, da área de Sucesso do Cliente da Voitto. Vi que você realizou a compra de material impresso do curso ${cleanTitle(product)}, porém seu cadastro não consta o endereço. Pode me passar o endereço de entrega, por gentileza?`
    )}`;

    window.open(link, "_blank");
  };

  return (
    <Content>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          width: "100%",
          marginTop: "1rem",
          gap: "1rem"
        }}
      >
        <Dropdown
          placeholder="Tipo"
          selection
          options={dropdownTipoOptions}
          onChange={(e, { value }) => setFilterType(value)}
          value={filterType}
        />

        <Dropdown
          placeholder="Status"
          selection
          options={dropdownStatusOptions}
          onChange={(e, { value }) => setFilterStatus(value)}
          value={filterStatus}
        />

        <Input
          style={{
            maxWidth: "600px",
            height: "100%",
            lineHeight: "1em",
            minHeight: "2.9em"
          }}
          placeholder="Pesquisa"
          onChange={(e) => setSearch(e.target.value)}
          value={search}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              // Chame a função de pesquisa ou dispare a ação desejada
              getEnvios();
            }
          }}
        />

        <Button onClick={() => getEnvios()}>Pesquisar</Button>

        {/* <Button onClick={() => setIsRelatorioModalOpen(true)}>
          Relatório
        </Button> */}
      </div>

      {loading ? (
        <div style={{
          width: "100%",
          marginTop: "2rem"
        }}>
          <Loader active inline="centered" size="small" />
        </div>
      ) : (
        <>
          <TableContainer component={Paper} style={{
            minWidth: "auto",
            marginTop: "2rem"
          }} >
            <Table sx={{ minWidth: 400 }} size="small" aria-label="a dense table">
              <TableHead style={{ position: "sticky", top: 0 }}>
                <TableRow style={{ textAlign: "left", backgroundColor: "#282828" }}>
                  <TableCell align="center" style={{ color: "#FFF" }}>Em Aberto</TableCell>
                  <TableCell align="center" style={{ color: "#FFF" }}>Enviado para Gráfica</TableCell>
                  <TableCell align="center" style={{ color: "#FFF" }}>Aguardando Código de Rastreio</TableCell>
                  <TableCell align="center" style={{ color: "#FFF" }}>Código enviado</TableCell>
                </TableRow>
              </TableHead>

              <TableBody >
                {
                  resultCount && (
                    <TableRow
                      hover
                      sx={{
                        '&:last-child td, &:last-child th': { border: 0 }
                      }}
                    >
                      <TableCell scope="row" align="center" >
                        <p style={{ padding: 0, margin: 0 }}>{resultCount?.em_aberto || 0}</p>
                      </TableCell>
                      <TableCell scope="row" align="center" >
                        <p style={{ padding: 0, margin: 0 }}>{resultCount?.em_preparacao || 0}</p>
                      </TableCell>
                      <TableCell scope="row" align="center" >
                        <p style={{ padding: 0, margin: 0 }}>{resultCount?.aguardando_codigo || 0}</p>
                      </TableCell>
                      <TableCell scope="row" align="center" >
                        <p style={{ padding: 0, margin: 0 }}>{resultCount?.codigo_enviado || 0}</p>
                      </TableCell>
                    </TableRow>
                  )
                }
              </TableBody>
            </Table>
          </TableContainer>
          <TableContainer component={Paper} style={{
            minWidth: "auto",
            marginTop: "1rem"
          }} >
            <Table sx={{ minWidth: 400 }} size="small" aria-label="a dense table">
              <TableHead style={{ position: "sticky", top: 0 }}>
                <TableRow style={{ textAlign: "left", backgroundColor: "#282828" }}>
                  <TableCell align="left" style={{ color: "#FFF" }}>Pedido</TableCell>
                  <TableCell align="left" style={{ color: "#FFF", width: "200px" }}>Aluno</TableCell>
                  <TableCell align="left" style={{ color: "#FFF" }}>Status</TableCell>
                  <TableCell align="left" style={{ color: "#FFF" }}>Tipo</TableCell>
                  {/* <TableCell align="left" style={{ color: "#FFF" }}>Data Compra</TableCell> */}
                  <TableCell align="left" style={{ color: "#FFF" }}>Ações</TableCell>
                  {/* <TableCell align="left" style={{ color: "#FFF" }}>Mensagem</TableCell> */}
                </TableRow>
              </TableHead>


              {
                envios ?
                  (
                    <TableBody >
                      {envios
                        // .sort((a,b) => a - b )
                        .map((envio, index) => (
                          <TableRow
                            hover
                            key={index}
                            // component={Link}
                            // to={`/admin/dashboard/aluno/${row.id_pessoa}`}
                            sx={{
                              '&:last-child td, &:last-child th': { border: 0 }
                            }}
                          >
                            <TableCell scope="row" align="center" >
                              <p style={{ padding: 0, margin: 0, textDecoration: "underline", cursor: "pointer" }} onClick={() => { handleDadosDoPedido(envio.id_pedido, envio.tipo); setIsOpenInfos(true) }} >{envio.id_pedido}</p>
                              {/* <DetailButton onClick={() => { handleDadosDoPedido(envio.id_pedido); setIsOpenInfos(true) }}>detalhes</DetailButton> */}
                            </TableCell>
                            <TableCell
                              style={{
                                whiteSpace: "nowrap",
                                overflow: "hidden"
                              }}
                            >
                              {`${envio.pessoa.nome}`}
                            </TableCell>
                            <TableCell align="left">
                              <Select defaultValue={envio.status_new} sx={{ marginLeft: 2 }} onChange={(e) => attEnvioStatus(envio.id, e.target.value)}>
                                <MenuItem value={0}>Em Aberto</MenuItem>
                                <MenuItem value={1}>Enviado para gráfica</MenuItem>
                                <MenuItem value={2}>Aguardando Código de Rastreio</MenuItem>
                                <MenuItem value={3}>Código de Rastreio Enviado</MenuItem>
                              </Select>

                            </TableCell>
                            <TableCell align="left">{envio.tipo === "material"
                              ? `Material:\n`
                              : `Certificado:\n`}
                              -  {envio.id_curso_item}
                            </TableCell>
                            {/* <TableCell align="left"> {smallDateFormatWithTime(new Date(envio.data))}</TableCell> */}
                            <TableCell align="left"

                            >
                              <FaTruck
                                style={{ cursor: "pointer" }}
                                size={20}
                                onClick={() => show("small", index, envio)} />
                              <FaWhatsapp size={20} onClick={() => handleOpenWPMessage(
                                envio.pessoa.celular,
                                envio.pessoa.nome,
                                cleanTitle(envio.curso.curso || "")
                              )}
                                style={{ marginLeft: "5px", cursor: "pointer" }} />
                            </TableCell>
                          </TableRow>
                        ))}

                    </TableBody>)
                  : <></>
              }
            </Table>
          </TableContainer>
          <Pagination
            style={{ margin: "1rem 0 2rem" }}
            activePage={page}
            onPageChange={(e, f) => setPage(f.activePage)}
            ellipsisItem={{
              content: <Icon name="ellipsis horizontal" />,
              icon: true,
            }}
            firstItem={{
              content: <Icon name="angle double left" />,
              icon: true,
            }}
            lastItem={{
              content: <Icon name="angle double right" />,
              icon: true,
            }}
            prevItem={{ content: <Icon name="angle left" />, icon: true }}
            nextItem={{ content: <Icon name="angle right" />, icon: true }}
            totalPages={pageQuant}
          />


          {/* MODAL DE ENVIO DE CÓDIGO DE RASTREIO */}
          <Modal open={open} onClose={close}>
            <Modal.Header>Atualizar envio</Modal.Header>

            <Modal.Content>
              <p style={{ textAlign: "center", fontWeight: 700 }}>
                Pedido: {modalDataEnvio?.id_pedido}
              </p>
              <p style={{ textAlign: "center", fontWeight: 700 }}>
                {modalDataEnvio?.curso?.curso}
              </p>

              <Field>
                <Label>Código de rastreamento</Label>
                <Input
                  value={modalCodigoRastreio}
                  onChange={(e) => handleCodigoRastreio(e)}
                />
              </Field>

              <Field>
                <SubmitButton onClick={() => sendCodigoRastreio(modalDataEnvio.id)}>
                  Enviar
                </SubmitButton>
                <Checkbox
                  label="Enviar email junto com a atualização?"
                  style={{ marginLeft: 5 }}
                  checked={sendMail}
                  onChange={(e, f) => setSendMail(prev => !prev)}
                />
              </Field>

              {/* <Segment.Group>
                <WarningRed as={Segment}>
                  Atenção ao atualizar este campo, pois ele aparecerá no email
                  de envio do usuário.
                </WarningRed>
              </Segment.Group>

              <Segment.Group>
                <WarningYellow as={Segment}>
                  Para informar um pedido em preparação coloqueo SRO como 0.
                </WarningYellow>
              </Segment.Group> */}
            </Modal.Content>

            <Modal.Actions>
              <Button negative onClick={(e) => close(e)}>
                Cancelar
              </Button>
            </Modal.Actions>
          </Modal>

          {/* MODAL DE RELATÓRIO DE ENVIOS */}
          {/* <Modal
            open={isRelatorioModalOpen}
            onClose={() => setIsRelatorioModalOpen(false)}
          >
            <Modal.Header>Relatório</Modal.Header>

            <Modal.Content>
              <Field>
                <Label>De</Label>
                <Input
                  onChange={(evt) => setRelatorioDataDe(evt.target.value)}
                  type="date"
                />
              </Field>

              <Field>
                <Label>Até</Label>
                <Input
                  onChange={(evt) => setRelatorioDataAte(evt.target.value)}
                  type="date"
                />
              </Field>
            </Modal.Content>

            <Modal.Actions>
              <Button
                negative
                onClick={(e) => setIsRelatorioModalOpen(false)}
              >
                Cancelar
              </Button>
              <Button positive onClick={handleRelatorio}>
                Gerar
              </Button>
            </Modal.Actions>
          </Modal> */}
          <Modal
            open={isOpenInfos}
            onClose={() => setIsOpenInfos(false)}
            size="small"
            style={{
              maxHeight: "80vh",
              overflowY: "scroll"
            }}
          >
            <Modal.Header>Dados do Pedido</Modal.Header>

            {
              loadDataPedido ? (
                <Modal.Content>
                  <div style={{
                    width: "100%",
                    margin: "0 auto",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}>
                    {/* <Loader active inline="centered" size="small" /> */}
                    <FullLoader />
                  </div>
                </Modal.Content>
              ) : (
                <Modal.Content>
                  <Field style={{ marginTop: 0, paddingTop: 0 }}>
                    <Label>Nome:</Label>
                    <p>{dataPedidoSelecionado?.pessoa?.nome || "Não encontrado"}</p>
                  </Field>

                  <Field>
                    <Label>Email:</Label>
                    <p>{dataPedidoSelecionado?.pessoa?.email}</p>
                  </Field>

                  <Field>
                    <Label>CPF:</Label>
                    <p>{dataPedidoSelecionado?.pessoa?.cpf}</p>
                  </Field>

                  <Field>
                    <Label>Endereço:</Label>
                    <p>
                      Rua: {dataPedidoSelecionado?.pessoa?.endereco}<br/>
                      Número: {dataPedidoSelecionado?.pessoa?.numero}<br/>
                      Bairro: {dataPedidoSelecionado?.pessoa?.bairro}<br/>
                      Cidade: {dataPedidoSelecionado?.pessoa?.cidade}<br/>
                      Estado: {dataPedidoSelecionado?.pessoa?.estado}<br/>
                      Cep: {dataPedidoSelecionado?.pessoa?.cep}<br/>
                      Complemento: {dataPedidoSelecionado?.pessoa?.complemento || "Sem complemento"}

                    </p>
                  </Field>

                  <Field>
                    <Label>Celular:</Label>
                    <p>{dataPedidoSelecionado?.pessoa?.celular}</p>
                  </Field>

                  <Field>
                    <Label>Curso Comprado:</Label>
                    <p>{cleanTitle(dataPedidoSelecionado?.curso_comprado)}</p>
                  </Field>

                  <Field>
                    <Label>Valor Pago:</Label>
                    <p>R$ {dataPedidoSelecionado?.valor_pago}</p>
                  </Field>

                  <Field>
                    <Label>Status do Pedido:</Label>
                    <p>{dataPedidoSelecionado?.status_pedido == 3 ? "Pago" : [0, 1, 2, 4].includes(Number(dataPedidoSelecionado.status)) ? "Pendente" : "Estorno"}</p>
                  </Field>

                  <Field>
                    <Label>Data de Pagamento:</Label>
                    <p>{smallDateFormat(dataPedidoSelecionado?.data_pagamento)}</p>
                  </Field>

                  {tipoVerificadoModal === 1 && dataPedidoSelecionado.solicitacao.material.length > 0 && (
                    <Field>
                      <Label>Solicitação de Materiais:</Label>
                      {dataPedidoSelecionado?.solicitacao?.material ?
                        dataPedidoSelecionado?.solicitacao?.material.map((material, index) => (
                          <p key={index}>{cleanTitle(material.curso)} - [{material.id_curso}]</p>
                        )) : "Não foi solicitado materiais"}
                    </Field>
                  )}

                  {tipoVerificadoModal === 0 && dataPedidoSelecionado.solicitacao.certificado.length > 0 && (
                    <Field>
                      <Label>Solicitação de Certificados:</Label>
                      {dataPedidoSelecionado.solicitacao.certificado ? dataPedidoSelecionado.solicitacao.certificado.map((certificado, index) => (
                        <p key={index}>
                          <p>{cleanTitle(certificado.curso)} - [{certificado.id_curso}]</p>
                         {dataPedidoSelecionado && dataPedidoSelecionado != "" &&  <a href={certificado.certificado_gerado} target="_blank" rel="noopener noreferrer">
                            Ver Certificado
                          </a>}
                        </p>
                      )) : "Não foi solicitado certificado"}
                    </Field>
                  )}
                </Modal.Content>
              )
            }
          </Modal>
        </>
      )}
    </Content>
  );
};

export default ControleEnvios;
